import {
  discoveryApiRef,
  fetchApiRef,
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { spmApiRef, SpmApiClient } from './api';
import tabs from './tabs';

const spmApi = ApiBlueprint.make({
  name: 'spmApi',
  params: defineParams =>
    defineParams({
      api: spmApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new SpmApiClient({ discoveryApi, fetchApi }),
    }),
});

export const devopsSpmPlugin = createFrontendPlugin({
  pluginId: 'devops-spm',
  routes: {
    root: rootRouteRef,
  },
  extensions: [spmApi, ...tabs],
});
